{
  "familyId": "STU-STAAF",
  "questions": [
    {
      "id": "STU-STAAF-001",
      "familyId": "STU-STAAF",
      "module": "Studievaardig",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_staafdiagram",
      "questionType": "bar_chart",
      "question": "Een marktonderzoeker peilt de favoriete fruitsoort. Vergelijk de staven en bepaal welk fruit het populairst is.",
      "context": null,
      "options": ["Appels", "Peren", "Bananen", "Druiven"],
      "correctAnswer": 0,
      "data": {
        "data": [
          { "label": "Appels", "value": 35 },
          { "label": "Peren", "value": 20 },
          { "label": "Bananen", "value": 28 },
          { "label": "Druiven", "value": 17 }
        ],
        "correctIndex": 0,
        "xAxisLabel": "Fruit",
        "yAxisLabel": "Aantal stemmen",
        "hideValues": true
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "barChart",
          "showWhen": "wrong",
          "data": {
            "data": [
              { "label": "Appels", "value": 35 },
              { "label": "Peren", "value": 20 },
              { "label": "Bananen", "value": 28 },
              { "label": "Druiven", "value": 17 }
            ],
            "xAxisLabel": "Fruit",
            "yAxisLabel": "Aantal stemmen",
            "hideValues": false
          }
        },
        {
          "type": "rule",
          "data": {
            "title": "Staafdiagram lezen",
            "content": "Zoek de hoogste staaf. Hoe hoger de staaf, hoe groter de waarde. Appels heeft de hoogste staaf (35 stemmen).",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "bar_chart_highest",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.80,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Regel voor staafdiagrammen: de hoogste staaf geeft de grootste waarde aan. Zoek de hoogste staaf in het diagram. Appels (35) is de hoogste, gevolgd door Bananen (28), Peren (20) en Druiven (17). Appels is het populairst.",
        "solutionSteps": [
          "Vergelijk de hoogte van alle staven",
          "Appels = 35, Bananen = 28, Peren = 20, Druiven = 17",
          "Appels (35) is de hoogste staaf",
          "Conclusie: Appels is het populairst ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Appels heeft de hoogste staaf met 35 stemmen — dat is het populairste fruit.",
          "1": "Je dacht waarschijnlijk dat Peren het populairst is. Maar Peren heeft 20 stemmen en Appels heeft 35 stemmen. Onthoud: de hoogste staaf = de grootste waarde.",
          "2": "Je dacht waarschijnlijk dat Bananen het populairst is. Bananen (28) komt dichtbij, maar Appels (35) is nog hoger. Onthoud: vergelijk alle staven zorgvuldig voordat je kiest.",
          "3": "Je dacht waarschijnlijk dat Druiven het populairst is. Maar Druiven (17) heeft juist de laagste staaf. Onthoud: de hoogste staaf = de grootste waarde, niet de laagste."
        }
      }
    },
    {
      "id": "STU-STAAF-002",
      "familyId": "STU-STAAF",
      "module": "Studievaardig",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_staafdiagram",
      "questionType": "bar_chart",
      "question": "Een sportcoördinator bekijkt de inschrijvingen. Vergelijk de staven en bepaal welke sport de meeste inschrijvingen heeft. Klik op de juiste staaf.",
      "context": null,
      "options": ["Voetbal", "Tennis", "Zwemmen", "Hockey"],
      "correctAnswer": 0,
      "data": {
        "data": [
          { "label": "Voetbal", "value": 42 },
          { "label": "Tennis", "value": 18 },
          { "label": "Zwemmen", "value": 30 },
          { "label": "Hockey", "value": 25 }
        ],
        "correctIndex": 0,
        "xAxisLabel": "Sport",
        "yAxisLabel": "Aantal leerlingen",
        "hideValues": true
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "barChart",
          "showWhen": "wrong",
          "data": {
            "data": [
              { "label": "Voetbal", "value": 42 },
              { "label": "Tennis", "value": 18 },
              { "label": "Zwemmen", "value": 30 },
              { "label": "Hockey", "value": 25 }
            ],
            "xAxisLabel": "Sport",
            "yAxisLabel": "Aantal leerlingen",
            "hideValues": false
          }
        },
        {
          "type": "rule",
          "data": {
            "title": "Hoogste staaf zoeken",
            "content": "Zoek de hoogste staaf. Voetbal (42) is de hoogste — dat is de sport met de meeste inschrijvingen.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "bar_chart_highest",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.80,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Regel voor staafdiagrammen: de hoogste staaf geeft de grootste waarde aan. Zoek de hoogste staaf in het diagram. Voetbal (42) is de hoogste, gevolgd door Zwemmen (30), Hockey (25) en Tennis (18). Voetbal heeft de meeste inschrijvingen.",
        "solutionSteps": [
          "Vergelijk de hoogte van alle staven",
          "Voetbal = 42, Zwemmen = 30, Hockey = 25, Tennis = 18",
          "Voetbal (42) is de hoogste staaf",
          "Conclusie: Voetbal heeft de meeste inschrijvingen ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Voetbal heeft de hoogste staaf met 42 inschrijvingen — dat is de sport met de meeste inschrijvingen.",
          "1": "Je dacht waarschijnlijk dat Tennis de meeste inschrijvingen heeft. Maar Tennis (18) heeft juist de laagste staaf. Onthoud: de hoogste staaf = de grootste waarde.",
          "2": "Je dacht waarschijnlijk dat Zwemmen de meeste inschrijvingen heeft. Maar Zwemmen (30) is lager dan Voetbal (42). Onthoud: vergelijk alle staven zorgvuldig.",
          "3": "Je dacht waarschijnlijk dat Hockey de meeste inschrijvingen heeft. Maar Hockey (25) is lager dan Voetbal (42). Onthoud: de hoogste staaf = de grootste waarde."
        }
      }
    },
    {
      "id": "STU-STAAF-003",
      "familyId": "STU-STAAF",
      "module": "Studievaardig",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_staafdiagram",
      "questionType": "bar_chart",
      "question": "Een meteoroloog bekijkt de neerslagcijfers. Vergelijk de staven en bepaal welke maand de minste regen had. Klik op de juiste staaf.",
      "context": null,
      "options": ["Januari", "Februari", "Maart", "April"],
      "correctAnswer": 1,
      "data": {
        "data": [
          { "label": "Januari", "value": 45 },
          { "label": "Februari", "value": 38 },
          { "label": "Maart", "value": 52 },
          { "label": "April", "value": 60 }
        ],
        "correctIndex": 1,
        "xAxisLabel": "Maand",
        "yAxisLabel": "Regen (mm)",
        "hideValues": true
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "barChart",
          "showWhen": "wrong",
          "data": {
            "data": [
              { "label": "Januari", "value": 45 },
              { "label": "Februari", "value": 38 },
              { "label": "Maart", "value": 52 },
              { "label": "April", "value": 60 }
            ],
            "xAxisLabel": "Maand",
            "yAxisLabel": "Regen (mm)",
            "hideValues": false
          }
        },
        {
          "type": "rule",
          "data": {
            "title": "Laagste staaf zoeken",
            "content": "Zoek de laagste staaf. Februari (38 mm) is de laagste — dat is de maand met de minste regen.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "bar_chart_lowest",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.79,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Regel voor staafdiagrammen: de laagste staaf geeft de kleinste waarde aan. Zoek de laagste staaf in het diagram. Februari (38 mm) is de laagste, gevolgd door Januari (45 mm), Maart (52 mm) en April (60 mm). Februari had de minste regen.",
        "solutionSteps": [
          "Vergelijk de hoogte van alle staven",
          "Januari = 45 mm, Februari = 38 mm, Maart = 52 mm, April = 60 mm",
          "Februari (38 mm) is de laagste staaf",
          "Conclusie: Februari had de minste regen ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat Januari de minste regen had. Maar Januari (45 mm) is hoger dan Februari (38 mm). Onthoud: de laagste staaf = de kleinste waarde.",
          "1": "Goed! Februari had met 38 mm de minste regen — de laagste staaf in het diagram.",
          "2": "Je dacht waarschijnlijk dat Maart de minste regen had. Maar Maart (52 mm) is juist een van de hogere staven. Onthoud: zoek de laagste staaf, niet een middelste.",
          "3": "Je dacht waarschijnlijk dat April de minste regen had. Maar April (60 mm) is juist de hoogste staaf — de meeste regen. Onthoud: 'minste' = laagste staaf, niet de hoogste."
        }
      }
    },
    {
      "id": "STU-STAAF-004",
      "familyId": "STU-STAAF",
      "module": "Studievaardig",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_staafdiagram",
      "questionType": "multiple_choice",
      "question": "Een schooldirecteur bekijkt de leerlingaantallen. Bereken hoeveel leerlingen er in totaal zijn door alle staven op te tellen.",
      "context": null,
      "options": ["85", "60", "90", "75"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "barChart",
          "data": {
            "data": [
              { "label": "Groep 6", "value": 28 },
              { "label": "Groep 7", "value": 32 },
              { "label": "Groep 8", "value": 25 }
            ],
            "xAxisLabel": "Groep",
            "yAxisLabel": "Aantal leerlingen",
            "hideValues": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "barChart",
          "showWhen": "wrong",
          "data": {
            "data": [
              { "label": "Groep 6", "value": 28 },
              { "label": "Groep 7", "value": 32 },
              { "label": "Groep 8", "value": 25 }
            ],
            "xAxisLabel": "Groep",
            "yAxisLabel": "Aantal leerlingen",
            "hideValues": false
          }
        },
        {
          "type": "rule",
          "data": {
            "title": "Totaal berekenen",
            "content": "Tel alle waarden bij elkaar op: 28 + 32 + 25 = 85 leerlingen in totaal.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "bar_chart_total",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.77,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.staaf-vergeet-laatste-staaf", "label": "Vergeet de laatste staaf op te tellen", "optionIndex": 1 },
          { "id": "stu.staaf-rekenfout-optellen", "label": "Rekenfout bij het optellen", "optionIndex": 2 },
          { "id": "stu.staaf-totaal-fout-getal", "label": "Totaal gegeven dat niet past bij de staven", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Regel: om het totaal te vinden, lees je eerst elke staaf af en tel je ze daarna allemaal op. Groep 6 = 28, Groep 7 = 32, Groep 8 = 25. Totaal: 28 + 32 + 25 = 85 leerlingen.",
        "solutionSteps": [
          "Lees af: Groep 6 = 28 leerlingen",
          "Lees af: Groep 7 = 32 leerlingen",
          "Lees af: Groep 8 = 25 leerlingen",
          "Tel op: 28 + 32 + 25 = 85",
          "Conclusie: 85 leerlingen in totaal ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 28 + 32 + 25 = 85 leerlingen in totaal.",
          "1": "Je dacht waarschijnlijk dat je maar twee groepen hoeft op te tellen. 28 + 32 = 60, maar je vergeet Groep 8 (25). Onthoud: tel alle staven op, niet alleen de eerste twee.",
          "2": "Je dacht waarschijnlijk dat het totaal 90 is. Maar 28 + 32 + 25 = 85, niet 90. Onthoud: controleer je optelling door terug te rekenen: 85 − 25 = 60, 60 − 32 = 28 ✓.",
          "3": "Je dacht waarschijnlijk dat het totaal 75 is. Maar 28 + 32 + 25 = 85, niet 75. Onthoud: tel stap voor stap op: eerst 28 + 32 = 60, dan 60 + 25 = 85."
        }
      }
    },
    {
      "id": "STU-STAAF-005",
      "familyId": "STU-STAAF",
      "module": "Studievaardig",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_staafdiagram",
      "questionType": "bar_chart",
      "question": "Een dierenarts houdt bij welke huisdieren het vaakst langskomen. Vergelijk de staven en bepaal welk huisdier het vaakst voorkomt. Klik op de juiste staaf.",
      "context": null,
      "options": ["Hond", "Kat", "Konijn", "Vis"],
      "correctAnswer": 1,
      "data": {
        "data": [
          { "label": "Hond", "value": 15 },
          { "label": "Kat", "value": 22 },
          { "label": "Konijn", "value": 8 },
          { "label": "Vis", "value": 12 }
        ],
        "correctIndex": 1,
        "xAxisLabel": "Huisdier",
        "yAxisLabel": "Aantal",
        "hideValues": true
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "barChart",
          "showWhen": "wrong",
          "data": {
            "data": [
              { "label": "Hond", "value": 15 },
              { "label": "Kat", "value": 22 },
              { "label": "Konijn", "value": 8 },
              { "label": "Vis", "value": 12 }
            ],
            "xAxisLabel": "Huisdier",
            "yAxisLabel": "Aantal",
            "hideValues": false
          }
        },
        {
          "type": "rule",
          "data": {
            "title": "Hoogste staaf",
            "content": "De hoogste staaf is Kat (22). Dat huisdier komt het vaakst voor bij de dierenarts.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "bar_chart_most_common",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.81,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Regel voor staafdiagrammen: de hoogste staaf geeft de grootste waarde aan. Zoek de hoogste staaf in het diagram. Kat (22) is de hoogste, gevolgd door Hond (15), Vis (12) en Konijn (8). Kat komt het vaakst voor bij de dierenarts.",
        "solutionSteps": [
          "Vergelijk de hoogte van alle staven",
          "Kat = 22, Hond = 15, Vis = 12, Konijn = 8",
          "Kat (22) is de hoogste staaf",
          "Conclusie: Kat komt het vaakst voor ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat Hond het vaakst voorkomt. Maar Hond (15) is lager dan Kat (22). Onthoud: vergelijk de hoogte van de staven, niet je verwachting.",
          "1": "Goed! Kat heeft de hoogste staaf met 22 — dat huisdier komt het vaakst voor bij de dierenarts.",
          "2": "Je dacht waarschijnlijk dat Konijn het vaakst voorkomt. Maar Konijn (8) heeft juist de laagste staaf. Onthoud: de hoogste staaf = het vaakst voorkomend.",
          "3": "Je dacht waarschijnlijk dat Vis het vaakst voorkomt. Maar Vis (12) is lager dan Kat (22) en Hond (15). Onthoud: vergelijk alle staven zorgvuldig."
        }
      }
    },
    {
      "id": "STU-STAAF-006",
      "familyId": "STU-STAAF",
      "module": "Studievaardig",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_staafdiagram",
      "questionType": "true_false_series",
      "question": "Een verkeerskundige toont een staafdiagram met het aantal voertuigen per type op een drukke weg: Auto 80, Fiets 55, Bus 12, Vrachtwagen 23. Welke uitspraken zijn waar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "Auto's komen het vaakst voor op deze weg.", "isTrue": true },
          { "text": "Bussen hebben de kortste staaf, dus er rijden er het minste van.", "isTrue": true },
          { "text": "Er rijden meer vrachtwagens dan fietsen.", "isTrue": false },
          { "text": "Auto en Fiets samen zijn meer dan 100 voertuigen.", "isTrue": true },
          { "text": "Een hogere staaf betekent altijd een groter percentage.", "isTrue": true }
        ]
      },
      "stimulusAids": [
        {
          "type": "barChart",
          "data": {
            "data": [
              { "label": "Auto", "value": 80 },
              { "label": "Fiets", "value": 55 },
              { "label": "Bus", "value": 12 },
              { "label": "Vrachtwagen", "value": 23 }
            ],
            "xAxisLabel": "Voertuigtype",
            "yAxisLabel": "Aantal"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Staafdiagram interpreteren",
            "content": "Hoogste staaf = grootste waarde. Laagste staaf = kleinste waarde. Vergelijk altijd de getallen, niet je verwachting.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "bar_chart_statements",
      "variantIndex": 6,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.staaf-verwacht-boven-data" },
          { "id": "stu.staaf-hoogste-laagste-omdraaien" }
        ]
      },
      "feedback": {
        "explanationText": "Auto (80) is de hoogste staaf en Bus (12) de laagste — beide waar. Vrachtwagen (23) is juist lager dan Fiets (55). Auto + Fiets = 80 + 55 = 135 > 100. Een hogere staaf hoort altijd bij een grotere waarde.",
        "solutionSteps": [
          "Lees de waarden af: Auto 80, Fiets 55, Bus 12, Vrachtwagen 23",
          "Controleer elke uitspraak afzonderlijk tegen de data",
          "Bereken combinaties indien nodig: 80 + 55 = 135",
          "Vergelijk staafhoogtes om waar/niet waar te bepalen"
        ]
      }
    },
    {
      "id": "STU-STAAF-007",
      "familyId": "STU-STAAF",
      "module": "Studievaardig",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_staafdiagram",
      "questionType": "ordering",
      "question": "Zet de stappen voor het lezen van een staafdiagram in de juiste volgorde.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Vergelijk de hoogte van de staven met elkaar",
          "Lees de titel en de aslabels (x-as en y-as)",
          "Trek een conclusie of beantwoord de vraag",
          "Lees per staaf de waarde af op de y-as"
        ],
        "correctOrder": [1, 3, 0, 2]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Staafdiagram lezen — stappenplan",
            "content": "1) Titel en assen lezen → 2) Waarden per staaf aflezen → 3) Staven vergelijken → 4) Conclusie trekken. Altijd in deze volgorde.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "bar_chart_reading_steps",
      "variantIndex": 7,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.staaf-conclusie-zonder-aflezen" }
        ]
      },
      "feedback": {
        "explanationText": "Eerst lees je de titel en aslabels (wat staat er in het diagram?). Dan lees je per staaf de waarde af. Vervolgens vergelijk je de staven. Pas daarna trek je een conclusie. Conclusie trekken zonder eerst af te lezen leidt tot fouten.",
        "solutionSteps": [
          "Stap 1: Lees titel en aslabels — wat meet dit diagram?",
          "Stap 2: Lees per staaf de waarde af op de y-as",
          "Stap 3: Vergelijk de staven onderling",
          "Stap 4: Trek een conclusie of beantwoord de vraag"
        ]
      }
    }
  ]
}